var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonIdealLowStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_radial_7252_94972)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7252_94972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8068 46.5086L59.2727 37.8876C59.2084 37.757 59.0797 37.6263 58.951 37.561L53.2238 34.2955C54.8969 31.8137 55.8621 28.8747 55.8621 25.6745C55.7978 16.9882 48.7193 10 39.9677 10C31.2804 10 24.2019 16.9882 24.2019 25.6092C24.2019 28.8094 25.1672 31.7484 26.8403 34.2302L21.1131 37.4957C20.9844 37.561 20.8557 37.6916 20.7914 37.8223L15.1286 46.5086C14.9999 46.7045 14.9355 47.0311 14.9999 47.227C15.0642 47.4882 15.2573 47.6842 15.4503 47.8148L20.534 50.6884V59.3747C20.534 59.7013 20.727 60.0278 21.0488 60.2238L39.5172 70.7388C39.6459 70.8041 39.839 70.8694 40.032 70.8694C40.2251 70.8694 40.3538 70.8041 40.5468 70.7388L58.951 60.2891C59.2727 60.0932 59.4657 59.7666 59.4657 59.44V50.7537L64.5494 47.8801C64.8068 47.7495 64.9355 47.5535 64.9999 47.2923C65.0642 47.0311 64.9355 46.7045 64.8068 46.5086ZM26.1324 25.6092C26.1324 18.0985 32.3744 11.9593 39.9677 11.9593C47.561 11.9593 53.8029 18.0985 53.8029 25.6092C53.8029 33.1199 47.6253 39.2591 39.9677 39.2591C32.3744 39.3244 26.1324 33.1852 26.1324 25.6092ZM39.9677 47.8148L23.5584 38.4101L28.0629 35.863C30.9587 39.1938 35.2701 41.2837 40.032 41.2837C44.7939 41.2837 49.1054 39.1938 52.0011 35.863L56.5056 38.4101L39.9677 47.8148Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9681 39.3243C47.5614 39.3243 53.8033 33.1851 53.8033 25.6744C53.8033 18.0984 47.6257 11.9592 39.9681 11.9592C32.3104 11.9592 26.1328 18.0984 26.1328 25.6091C26.1328 33.1851 32.3748 39.3243 39.9681 39.3243Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3594 28.6134C38.3594 29.9196 38.3594 31.2258 38.3594 32.4667C38.3594 33.6423 39.0029 34.2954 39.9681 34.2954C40.9334 34.2954 41.5769 33.6423 41.5769 32.4667C41.5769 29.8543 41.5769 27.3072 41.5769 24.6948C41.5769 23.4539 40.9334 22.8008 39.9681 22.8008C39.0029 22.8008 38.4237 23.4539 38.4237 24.6295C38.3594 26.0663 38.3594 27.3725 38.3594 28.6134Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6413 18.5556C41.6413 17.7066 40.9335 16.9882 40.0969 16.9882C39.196 16.9229 38.4238 17.7066 38.4238 18.6209C38.4238 19.47 39.196 20.1884 39.9682 20.2537C40.8691 20.1884 41.577 19.47 41.6413 18.5556Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8854 39.7163L38.6164 49.2516L34.1119 56.2399L17.3809 46.7045L21.8854 39.7163Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.407 58.9176L39.9682 68.8448L22.5293 58.9176V51.9294L33.9193 58.4604C34.048 58.5257 34.241 58.591 34.4341 58.591C34.7558 58.591 35.0776 58.4604 35.2706 58.1339L39.9682 50.8191L44.6657 58.1339C44.8588 58.3951 45.1805 58.591 45.5023 58.591C45.6953 58.591 45.824 58.5257 46.0171 58.4604L57.407 51.9294V58.9176Z",
    fill: "#AEB5BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8873 56.2399L41.3828 49.2516L58.1138 39.7163L62.554 46.7045L45.8873 56.2399Z",
    fill: "#AEB5BE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7252_94972",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 7) rotate(66.1979) scale(79.7862)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7252_94972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 61,
    fill: "white",
    transform: "translate(15 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonIdealLowStock);
export default __webpack_public_path__ + "static/media/NonIdealLowStock.7ecf08253f1a9fe8819170270a1ad1e0.svg";
export { ForwardRef as ReactComponent };